import { createContext, useContext } from 'react';
import { COLOR_PRESETS } from './colorPresets';

export const ThemeContext = createContext();

export const ThemeProvider = ({ children, themeName = 'tealCoral' }) => {
  const theme = COLOR_PRESETS[themeName] || COLOR_PRESETS.professional;
  return (
    <ThemeContext.Provider value={theme}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};